export default __webpack_public_path__ + "static/media/scholar-instructions-1.1055816c.svg";